import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import Dialog from '@/components-v2/v2-dialog/index';
import publicMethods from '@mixin/publicMethods';
export default {
  name: "electronicInvoice-details",
  components: {
    Dialog: Dialog
  },
  props: {
    detailData: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      redMore: "查看更多",
      r_icon: "https://obs.pujian.com/frontend/app/user/r_wait.png",
      isReadMore: true,
      isShowEmail: false,
      isShowInvoice: false,
      customerMail: "",
      carousels: ["https://inv.jss.com.cn/fp/EXdTCOEglp5R4JiNnpazyypXYwfI01VfGeDZOUZ0YACdmdQQFmSlTgJ6JZxC8gpRZbA3WM9GPvl2Bi3A8l8C5Q.pdf", "https://inv.jss.com.cn/fp/EahyAvzKiOuM9Czvxppc07zIdw9aOX-5wN9iW-RW26XQe1_65wkoXSEgbs5GG73Lvm85kxp1MMMQbdIwVUTAzg.pdf", "https://inv.jss.com.cn/fp/-IVO9F3_xudPATK6PmCPDaiDIxKeF2qIF7n8fzdATp_9p2Z3ibNi1DrofVc3AcUDIW80xYaLCXZUdT3ZdmwOWg.pdf"],
      arrow: true,
      arrowBoth: true,
      arrowHover: false,
      actUrl: 0,
      invoiceIds: []
    };
  },
  mixins: [publicMethods],
  computed: {
    isShowPreviewInvoice: function isShowPreviewInvoice() {
      var _this$detailData = this.detailData,
        invoiceStatus = _this$detailData.invoiceStatus,
        invoiceType = _this$detailData.invoiceType;
      if (invoiceStatus == 3 && invoiceType >= 51) {
        return true;
      }
      return false;
    }
  },
  methods: {
    changeMore: function changeMore() {
      this.isReadMore = !this.isReadMore;
      this.redMore = this.isReadMore ? "收起" : "查看更多";
    },
    changeUrl: function changeUrl(e) {
      this.actUrl = e;
      console.log(e);
    },
    openEmail: function openEmail() {
      this.invoiceIds = [];
      this.invoiceIds = this.detailData.invoiceList.map(function (value) {
        return value.invoiceId;
      });
      this.getEmail();
      this.isShowEmail = true;
    },
    //下载发票
    invoiceDownload: function invoiceDownload() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var str, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.invoiceIds = [];
              _this.invoiceIds = _this.detailData.invoiceList.map(function (value) {
                return value.invoiceId;
              });
              str = _this.invoiceIds.join(",");
              _context.next = 5;
              return _this.$getHttpClient().get("/pjyy-deepexi-order-center/api/v1/order/OcOrderEInvoice/downInvoice?invoiceIds=" + str);
            case 5:
              res = _context.sent;
              if (res.data.code == 200) {
                window.open(res.data.msg, '_blank');
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    //返回发票中心
    backInvoice: function backInvoice() {
      this.$emit("backInvoice", true);
    },
    //复制链接
    invoiceCopy: function invoiceCopy() {
      this.invoiceIds = [];
      this.invoiceIds = this.detailData.invoiceList.map(function (value) {
        return value.invoiceId;
      });
      var str = this.invoiceIds.join(",");
      var ENV_APP = process.env.VUE_APP_API_SERVER;
      var openUrl = "";
      if (ENV_APP == "https://api-uat.pujian.com") {
        openUrl = "https://pay-uat.pujian.com/#/invoicePreview?invoiceIds=" + str;
      } else if (ENV_APP == "https://api-pre.pujian.com") {
        openUrl = "https://pay-pre.pujian.com/#/invoicePreview?invoiceIds=" + str;
      } else if (ENV_APP == "https://api.pujian.com") {
        openUrl = "https://pay.pujian.com/#/invoicePreview?invoiceIds=" + str;
      }
      // 模拟 输入框
      var cInput = document.createElement("textarea");
      cInput.value = "【普健医药】发票预览\r\n" + openUrl;
      document.body.appendChild(cInput);
      cInput.select(); // 选取文本框内容
      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand("copy");
      // 复制成功后再将构造的标签 移除
      document.body.removeChild(cInput);
      this.$buefy.toast.open({
        message: "发票链接复制成功",
        type: "is-success"
      });
    },
    //保存邮箱
    saveEmail: function saveEmail() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.$getHttpClient().post("/pjyy-deepexi-order-center/api/v1/order/OcOrderEInvoice/saveEmail", {
                email: _this2.customerMail
              });
            case 2:
              res = _context2.sent;
              if (res.data.code == 200) {}
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    //获取邮箱
    getEmail: function getEmail() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.$getHttpClient().get("/pjyy-deepexi-order-center/api/v1/order/OcOrderEInvoice/getEmail");
            case 2:
              res = _context3.sent;
              if (res.data.code == 200) {
                _this3.customerMail = res.data.msg;
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    //邮箱验证
    checkEmail: function checkEmail(email) {
      return RegExp(/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/).test(email);
    },
    //发送邮箱
    subEmailShare: function subEmailShare() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (_this4.checkEmail(_this4.customerMail)) {
                _context4.next = 3;
                break;
              }
              _this4.$buefy.toast.open({
                message: "请填写正确的邮箱地址",
                type: "is-danger"
              });
              return _context4.abrupt("return", false);
            case 3:
              _context4.next = 5;
              return _this4.$getHttpClient().post("/pjyy-deepexi-order-center/api/v1/order/OcOrderEInvoice/sendEmail", {
                customerMail: _this4.customerMail,
                invoiceIds: _this4.invoiceIds
              });
            case 5:
              res = _context4.sent;
              if (res.data.code == 200) {
                _this4.$buefy.toast.open({
                  message: "分享成功",
                  type: "is-success"
                });
                _this4.saveEmail();
              }
              _this4.isShowEmail = false;
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    //查看订单详情
    toOrderDetail: function toOrderDetail(orderNumber) {
      this.$router.push({
        name: "v2-orderpage",
        params: {
          orderNumber: orderNumber
        }
      });
    }
  }
};